import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function KVKK() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-emerald-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Button
          variant="outline"
          onClick={() => navigate('/')}
          className="mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Ana Sayfaya Dön
        </Button>

        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-slate-800 mb-6">KVKK Aydınlatma Metni</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-lg text-slate-600 mb-6">
              <strong>Son Güncelleme:</strong> {new Date().toLocaleDateString('tr-TR')}
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">1. Veri Sorumlusu</h2>
            <p className="text-slate-700 mb-4">
              6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; 
              veri sorumlusu olarak Mizaç360 tarafından aşağıda açıklanan kapsamda işlenebilecektir.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">2. İşlenen Kişisel Veriler</h2>
            <p className="text-slate-700 mb-4">Platformumuzda işlenen kişisel veriler:</p>
            <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
              <li>Kimlik Bilgileri: Ad, soyad, doğum tarihi</li>
              <li>İletişim Bilgileri: E-posta adresi, telefon numarası</li>
              <li>Eğitim Bilgileri: Sınıf seviyesi, okul bilgisi</li>
              <li>Değerlendirme Bilgileri: Mizaç testi sonuçları, raporlar</li>
              <li>İşlem Güvenliği Bilgileri: IP adresi, çerez verileri, oturum bilgileri</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">3. Kişisel Verilerin İşlenme Amaçları</h2>
            <p className="text-slate-700 mb-4">Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
            <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
              <li>Mizaç değerlendirmesi ve kişiselleştirilmiş raporların oluşturulması</li>
              <li>AI destekli koçluk hizmetlerinin sunulması</li>
              <li>Kullanıcı hesap yönetimi ve kimlik doğrulama</li>
              <li>Hizmet kalitesinin artırılması ve platform performansının izlenmesi</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              <li>İletişim faaliyetlerinin yürütülmesi</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">4. Kişisel Verilerin Aktarılması</h2>
            <p className="text-slate-700 mb-4">
              Kişisel verileriniz, KVKK'nın 8. ve 9. maddelerinde belirtilen şartlara uygun olarak:
            </p>
            <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
              <li>Yasal yükümlülükler kapsamında resmi kurumlara</li>
              <li>Hizmet sağlayıcılarımıza (bulut hizmetleri, AI servisleri)</li>
              <li>İş ortaklarımıza (eğitim kurumları, danışmanlar)</li>
            </ul>
            <p className="text-slate-700 mb-4">
              aktarılabilecektir. Tüm aktarımlar şifreli ve güvenli kanallar üzerinden yapılmaktadır.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">5. Kişisel Veri Sahibinin Hakları</h2>
            <p className="text-slate-700 mb-4">KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri:</p>
            <ul className="list-disc list-inside text-slate-700 space-y-2 mb-4">
              <li>Kişisel verilerinin işlenip işlenmediğini öğrenme</li>
              <li>İşlenmişse buna ilişkin bilgi talep etme</li>
              <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
              <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
              <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini isteme</li>
              <li>Düzeltme, silme veya yok edilme işlemlerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
              <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhine bir sonucun ortaya çıkmasına itiraz etme</li>
              <li>Kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme</li>
            </ul>
            <p className="text-slate-700 mb-4">
              haklarına sahiptir. Bu haklarınızı kullanmak için <a href="mailto:kvkk@mizac360.com" className="text-blue-600 hover:underline">kvkk@mizac360.com</a> adresine başvurabilirsiniz.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">6. Güvenlik</h2>
            <p className="text-slate-700 mb-4">
              Kişisel verileriniz, KVKK'nın 12. maddesi gereğince güvenli bir şekilde saklanmakta ve 
              yetkisiz erişimlere karşı teknik ve idari tedbirler alınmaktadır. Tüm veriler şifreli olarak 
              saklanır ve yalnızca yetkili personel tarafından erişilebilir.
            </p>

            <h2 className="text-2xl font-bold text-slate-800 mt-8 mb-4">7. İletişim</h2>
            <p className="text-slate-700 mb-4">
              KVKK kapsamındaki haklarınız veya kişisel verilerinizin işlenmesi hakkında sorularınız için:
            </p>
            <p className="text-slate-700">
              <strong>E-posta:</strong> <a href="mailto:kvkk@mizac360.com" className="text-blue-600 hover:underline">kvkk@mizac360.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
